import React from "react";
import { Modal } from "../../SharedComponents";
import { ModalNames } from "../../../Constants/modalNames";
import { Div, Icon, Text } from "../../Kit";
import { useModal } from "../../../Store/modules/modal/modal";
import { replaceUtmToLamtakam } from "../../../Utils/stringProcessor";
import { useTheme, useThemeColors } from "../../../Store/modules/theme";

export const ResourcesModal: React.FC = () => {
  const { modalProps } = useModal();
  const { resources } = modalProps;
  const { name: themeStatus } = useTheme();
  const [theme] = useThemeColors();

  return (
    <Modal
      modalName={ModalNames.ResourcesModal}
      ignorePadding
      modalClassName="w-[516px] max-h-[414px] rounded-[5px] overflow-y-auto hide-scrollbar"
      showCloseIcon
    >
      <div className="pt-[16px] pb-[34px] px-[30px]" dir="ltr">
        {resources?.map((resource: any, index: number) => (
          <a
            className="decoration-0"
            href={replaceUtmToLamtakam(resource.link)}
            target="_blank"
            dir="ltr"
          >
            <div>
              <div className="mt-[15px] flex items-center">
                <img
                  src={resource.favicon}
                  className="rounded-full w-[20px] h-[20px] border border-white"
                  alt="resource"
                />
                <Text elementType="span" className="mx-2 text-[14px]" fontWeight={400}>
                  {resource.link.split("/")?.[2]}
                </Text>
              </div>
              <Text
                elementType="p"
                className="mt-1 text-left text-[15px] mx-[28px]"
                fontWeight={600}
              >
                {resource.title}
              </Text>
            </div>
            {index + 1 !== resources.length ? (
              <Div className="w-full h-[1px] mt-[14px]" bg="border" />
            ) : null}
          </a>
        ))}
      </div>
    </Modal>
  );
};
